"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkedRecordFieldValueGetter = void 0;
const safe_field_value_1 = require("../../safe-field-value");
const get_value_1 = require("../get-value");
const arrays_1 = require("../../type-checking/arrays");
class LinkedRecordFieldValueGetter extends safe_field_value_1.BaseFieldValueGetter {
    constructor() {
        super(...arguments);
        this.isValidFieldValue = (fieldValue) => {
            return (0, arrays_1.isArrayOfIDsValue)(fieldValue);
        };
        this.getEmptyValue = () => (0, get_value_1.getReferenceEmptyValue)();
    }
}
exports.LinkedRecordFieldValueGetter = LinkedRecordFieldValueGetter;
